import React from 'react'
import { Link } from 'react-router-dom'
import './WelcomeScreen.scss'

function WelcomeScreen() {
  return (
    <div className="welcome-screen">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-xl-7">
            <div className="welcome-card">
              {/* Welcome Icon */}
              <div className="welcome-icon">
                <div className="icon-circle">
                  <span className="icon-emoji">👋</span>
                </div>
              </div>

              {/* Welcome Heading */}
              <h1 className="welcome-heading">
                Welcome to JobsReady<span className="ai-gradient">AI</span>!
              </h1>
              
              <p className="welcome-subtitle">
                We're excited to help you land your dream job. Let's get started!
              </p>

              {/* Main Message */}
              <div className="welcome-message">
                <p className="message-text">
                  To create personalized, AI-powered resumes tailored to each job posting, 
                  we first need to learn about your professional background.
                </p>
              </div>

              {/* Process Overview */}
              <div className="process-overview">
                <h2 className="process-title">Here's how it works:</h2>
                
                <div className="process-steps">
                  <div className="process-step">
                    <div className="step-number">1</div>
                    <div className="step-content">
                      <h3 className="step-title">Set Up Your Profile</h3>
                      <p className="step-description">
                        Add your work experience, education, skills, and contact information. 
                        You can upload your existing resume or fill it out manually.
                      </p>
                    </div>
                  </div>

                  <div className="process-step">
                    <div className="step-number">2</div>
                    <div className="step-content">
                      <h3 className="step-title">Import Job Postings</h3>
                      <p className="step-description">
                        Paste job URLs or manually add job postings you're interested in. 
                        Our AI will analyze each position.
                      </p>
                    </div>
                  </div>

                  <div className="process-step">
                    <div className="step-number">3</div>
                    <div className="step-content">
                      <h3 className="step-title">Generate Tailored Resumes</h3>
                      <p className="step-description">
                        Get AI-optimized resumes that highlight your most relevant experience 
                        for each job posting. Download and apply with confidence!
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Call to Action */}
              <div className="welcome-cta">
                <Link to="/profile" className="btn btn-primary btn-lg cta-button">
                  <span className="btn-icon">✨</span>
                  Set Up Your Profile
                </Link>
                <p className="cta-hint">
                  This will only take a few minutes, and you can always update it later.
                </p>
              </div>

              {/* Encouragement */}
              <div className="encouragement">
                <p className="encouragement-text">
                  💪 You've got this! Let's build a resume that gets you noticed.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WelcomeScreen

